// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var Warning = require("@mui/icons-material/Warning").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function Warning_modal(props) {
  var onClose = props.onClose;
  var onHideChange = props.onHideChange;
  var hideInit = props.hideInit;
  var match = React.useState(function () {
        return hideInit;
      });
  var setHide = match[1];
  var actHideChange = function (newHide) {
    setHide(function (param) {
          return newHide;
        });
    onHideChange(newHide);
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement("span", {
                            style: {
                              color: "#FF7900",
                              fontWeight: "bold"
                            }
                          }, props.title), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement("span", {
                                            style: {
                                              color: "#FF7900"
                                            }
                                          }, React.createElement(Warning, {}))), React.createElement("td", {
                                        style: {
                                          padding: "10px"
                                        }
                                      }, props.warningText)))), React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(Button, {
                                onClick: (function (param) {
                                    onClose();
                                  }),
                                variant: "contained",
                                children: "Ok"
                              }), React.createElement(FormControlLabel, {
                                control: React.createElement(Checkbox, {
                                      checked: match[0],
                                      onChange: Expln_React_common.evt2bool(actHideChange)
                                    }),
                                label: "Don't show again"
                              }))))
            });
}

var make = Warning_modal;

exports.make = make;
/* react Not a pure module */
